import { useQuery } from "$hooks";
import { NotificationsConfig } from "$config";
import { HAS_UNREAD_APPLICANT_NOTIFICATIONS } from "$queries";
import { useCurrentUser } from "./useCurrentUser";
import { ApprovalStatus } from "$interfaces/ApprovalStatus";

export const useHasUnreadApplicantNotifications = () => {
  const currentUser = useCurrentUser();
  const applicant = currentUser.data?.getCurrentUser?.applicant;
  const isApproved = applicant?.approvalStatus === ApprovalStatus.approved;
  const isRejected = applicant?.approvalStatus === ApprovalStatus.rejected;
  const shouldSkipQuery = !(isApproved || isRejected);

  const response = useQuery<{}, IResponse>(HAS_UNREAD_APPLICANT_NOTIFICATIONS, {
    pollInterval: NotificationsConfig.pollInterval,
    skip: shouldSkipQuery
  });
  return response.data && response.data.hasUnreadApplicantNotifications.hasUnreadNotifications;
};

interface IResponse {
  hasUnreadApplicantNotifications: { hasUnreadNotifications: boolean };
}
